let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("107zu"), load("tLGOl")]).then(() => parcelRequire('anKEx'));